import React, {ReactNode} from 'react';
import {useEnvironmentStore} from '@di-shared/features/environment/environmentStore';
import {BrandType, DeviceType, RegionType} from '@shared/cci/features/const/environment';

export interface EnvironmentProps {
  children: ReactNode;
}

function EnvironmentRoot(): JSX.Element {
  // 일단 하는일 없음
  return <></>;
}

function Pc({children}: EnvironmentProps) {
  const {device, isWebview} = useEnvironmentStore(({device, isWebview}) => ({device, isWebview}));

  if (isWebview || device !== DeviceType.PC) {
    return null;
  }

  return <>{children}</>;
}

function Tablet({children}: EnvironmentProps) {
  const {device, isWebview} = useEnvironmentStore(({device, isWebview}) => ({device, isWebview}));

  if (isWebview || device !== DeviceType.TABLET) {
    return null;
  }

  return <>{children}</>;
}

function Mobile({children}: EnvironmentProps) {
  const {device, isWebview} = useEnvironmentStore(({device, isWebview}) => ({device, isWebview}));

  if (isWebview || device !== DeviceType.MOBILE) {
    return null;
  }

  return <>{children}</>;
}

function WebView({children}: EnvironmentProps) {
  const {isWebview} = useEnvironmentStore(({isWebview}) => ({isWebview}));

  if (!isWebview) {
    return null;
  }

  return <>{children}</>;
}

function Kr({children}: EnvironmentProps) {
  const {region} = useEnvironmentStore(({region}) => ({region}));

  if (region !== RegionType.KR) {
    return null;
  }

  return <>{children}</>;
}

function Eu({children}: EnvironmentProps) {
  const {region} = useEnvironmentStore(({region}) => ({region}));

  if (region !== RegionType.EU) {
    return null;
  }

  return <>{children}</>;
}

function Na({children}: EnvironmentProps) {
  const {region} = useEnvironmentStore(({region}) => ({region}));

  if (region !== RegionType.NA) {
    return null;
  }

  return <>{children}</>;
}

function Kia({children}: EnvironmentProps) {
  const brand = import.meta.env.VITE_BRAND as 'KIA' | 'HYUNDAI' | 'GENESIS';

  if (brand !== BrandType.KIA) {
    return null;
  }

  return <>{children}</>;
}

function Hyundai({children}: EnvironmentProps) {
  const brand = import.meta.env.VITE_BRAND as 'KIA' | 'HYUNDAI' | 'GENESIS';

  if (brand !== BrandType.HYUNDAI) {
    return null;
  }

  return <>{children}</>;
}

function Genesis({children}: EnvironmentProps) {
  const brand = import.meta.env.VITE_BRAND as 'KIA' | 'HYUNDAI' | 'GENESIS';

  if (brand !== BrandType.GENESIS) {
    return null;
  }

  return <>{children}</>;
}

const Environment = Object.assign(EnvironmentRoot, {
  Kr,
  Eu,
  Na,
  Pc,
  Kia,
  Hyundai,
  Genesis,
  Tablet,
  Mobile,
  WebView,
});

export default Environment;
